import { render, staticRenderFns } from "./AttachmentNewDialog.vue?vue&type=template&id=5bc3c4b6&scoped=true&"
import script from "./AttachmentNewDialog.vue?vue&type=script&lang=ts&"
export * from "./AttachmentNewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentNewDialog.vue?vue&type=style&index=0&id=5bc3c4b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3c4b6",
  null
  
)

export default component.exports